import { render, staticRenderFns } from "./TransactionTypesPaginateComponent.vue?vue&type=template&id=6fb39537"
import script from "./TransactionTypesPaginateComponent.js?vue&type=script&lang=js&external"
export * from "./TransactionTypesPaginateComponent.js?vue&type=script&lang=js&external"
import style0 from "./TransactionTypesPaginateComponent.vue?vue&type=style&index=0&id=6fb39537&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports